import { render, staticRenderFns } from "./WebformPage.vue?vue&type=template&id=280d683e"
import script from "./WebformPage.vue?vue&type=script&lang=js"
export * from "./WebformPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports